import React, { useState, useContext } from "react";
import { MDBRow, MDBCard, MDBCardBody, MDBCardHeader, MDBCol, MDBPopover, MDBPopoverBody } from "mdb-react-ui-kit";
import CommonViewLayout from "./CommonViewLayout";
import constants from "../../../config/constants";
import { UserContext } from '../../../Context/UserContext';
import { isWindows } from "../../../Common/index.js";
import { HasPermission } from "../../../Utilities/CommonFunctions";
const Support = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const isWindowsSys = isWindows();
  const { user } = useContext(UserContext);
  const handleMouseEnter = () => {
    setIsPopoverOpen(true);
  };

  const handleMouseLeave = () => {
    setIsPopoverOpen(false);
  };

  return (
    <CommonViewLayout
      headerTitle="Support"
      iconName="headphones-alt"
    >
      <section>
        <MDBRow>
          <MDBCol lg="8" className="mb-4 mb-lg-0">
            <MDBRow>
              <MDBCol lg="6" className="mb-4">
                <BlockLayout title="Knowledge Base" description="Review our resource documents for quick answers and to strengthen your PB knowledge." href={constants.knowledgeBase} />
              </MDBCol>
              <MDBCol lg="6" className="mb-4">
                <BlockLayout title="Request Support" description="Not finding the answer in our Knowledge Base? Our specialists are here to help." href={constants.requestSupport} />
              </MDBCol>
              {((user.isBetaParticipant == "true" || user.accountType == "Support") && isWindowsSys && HasPermission("PBossConnect")) &&
              <MDBCol lg="6" className="mb-4" style={{ display: "flex", flexDirection: "column" }}>
                <BlockLayout title="PropertyHost Client for Windows" description="The RDP Client is required to launch the Hosted PropertyBoss program." href={constants.propertyHostClientForWindow}
                  handleMouseEnter={handleMouseEnter}
                  handleMouseLeave={handleMouseLeave} />
                <MDBPopover
                  open={isPopoverOpen}
                  placement='right'
                  btnClassName="lowVisibility"
                  options={{
                    modifiers: [
                      {
                        name: 'flip',
                        options: {
                          fallbackPlacements: ['bottom', 'top'],
                        },
                      },
                      {
                        name: 'offset',
                        options: {
                          offset: [0, -50]
                        },
                      },
                    ],
                  }}
                  poperStyle={{
                    backgroundColor: "#6d6d6d"
                  }}
                >
                  <MDBPopoverBody style={{color: "#ffffff"}}>
                    <ol>
                      <li>Download the client</li>
                      <li>Choose "Open" and "Run" to install</li>
                      <li>Click "Connect" in PB Online to launch</li>
                    </ol>
                  </MDBPopoverBody>
                </MDBPopover>
              </MDBCol>}
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </section>
    </CommonViewLayout>
  );
};
const BlockLayout = ({ title, description, href, handleMouseEnter, handleMouseLeave }) => {
  return (
    <MDBCard className="text-center" onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      <MDBCardHeader style={{fontSize: "14px"}} className="bg-light border-0">
        <>{title}</>
      </MDBCardHeader>
      <MDBCardBody>
        <div className="d-flex justify-content-center">
          <div>
            <p className="mb-2">
              <small style={{fontSize: "12px"}}>{description}</small>
            </p>
            <a href={href} style={{fontSize: "12px"}} target="_blank" rel="noopener noreferrer">
              Click Here
            </a>
          </div>
        </div>
      </MDBCardBody>
    </MDBCard>
  )
}

export default Support;
